// src/i18n/en/activityMonitorMetrics.ts

export const activityMonitorMetrics = {
  metrics: {
    eventsPerMinute: 'Events per minute - Real-time activity rate',
    avgSessionTime: 'Average session duration in minutes',
    eventsMin: 'Events/min',
    avgTime: 'Avg Time',
  },
  active: 'Active',
  completed: 'Completed',
  errors: 'Errors',
};

export default activityMonitorMetrics;
